import { Outlet } from 'react-router'
import RouteTabs from '@/components/common/RouteTabs'
import type { RouteTabItem } from '@/components/common/RouteTabs'

const TABS: RouteTabItem[] = [
  { label: 'Model', href: '/settings/model' },
  { label: 'Platforms', href: '/settings/platforms' },
  { label: 'Account', href: '/settings/account' },
  { label: 'Notifications', href: '/settings/notifications' },
  { label: 'Danger Zone', href: '/settings/danger-zone' },
]

export default function SettingsLayout() {
  return (
    <RouteTabs tabs={TABS}>
      <Outlet />
    </RouteTabs>
  )
}
